import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import React from 'react';
import TicketMainImage from '../../assets/confirmDeparture/ticket_main.png';
import ChevronIcon from '../../assets/confirmDeparture/icon_chevron.png';
import styled from 'styled-components';
import {
  TICKET_PLACE,
  WIFI_AIRPORTS,
  WIFI_PORTS,
} from '@/constant/departure.const';
import ImageCover from '@/components/MedicalDepartureWifi/ImageCover';
import { ICON_DEPARTURE } from '@repo/assets';

function MedicalKorDepartureLocation() {
  return (
    <ReceiptLayout>
      <ImageCover img={TicketMainImage} />
      <Container>
        <Header>
          <Title>
            <img src={ICON_DEPARTURE} alt='' />
            출국 장소 선택
          </Title>
          <Description>출국 예정인 공항 혹은 항구를 선택해주세요.</Description>
        </Header>
        <LinkButtonWrapper>
          <LinkButton href='/departure-wifi?place=airport'>
            <PlaceList>
              {WIFI_AIRPORTS.map(({ ko, en }) => {
                return (
                  <PlaceItem key={en}>
                    <KoName>{ko}</KoName>
                    <EngName>{en}</EngName>
                  </PlaceItem>
                );
              })}
            </PlaceList>
            <img
              src={ChevronIcon}
              alt='와이파이 연결 페이지로 이동하기'
              width={24}
              height={24}
            />
          </LinkButton>
          <LinkButton href='/departure-wifi?place=port'>
            <PlaceList>
              {WIFI_PORTS.map(({ ko, en }) => {
                return (
                  <PlaceItem key={en}>
                    <KoName>{ko}</KoName>
                    <EngName>{en}</EngName>
                  </PlaceItem>
                );
              })}
            </PlaceList>
            <img
              src={ChevronIcon}
              alt='와이파이 연결 페이지로 이동하기'
              width={24}
              height={24}
            />
          </LinkButton>
          <LinkButton href='/upload-ticket'>
            <PlaceList>
              {TICKET_PLACE.map(({ ko, en }) => {
                return (
                  <PlaceItem key={en}>
                    <KoName>{ko}</KoName>
                    <EngName>{en}</EngName>
                  </PlaceItem>
                );
              })}
            </PlaceList>
            <img
              src={ChevronIcon}
              alt='항공권 업로드 페이지로 이동하기'
              width={24}
              height={24}
            />
          </LinkButton>
        </LinkButtonWrapper>
      </Container>
    </ReceiptLayout>
  );
}

const Container = styled.section`
  width: calc(100% + 40px);
  margin-top: 120px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 20px 20px 0 0;
  z-index: 10;
`;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`;

const Title = styled.h2`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  font-weight: 700;
  color: #3a3b3e;

  & > img {
    width: 36px;
    height: 36px;
  }
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #80848a;
`;

const LinkButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const LinkButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 24px;
  border: 1px solid #e5e6e8;
  border-radius: 12px;
`;

const PlaceList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const PlaceItem = styled.li`
  display: flex;
  flex-direction: column;
`;

const KoName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #3a3b3e;
  line-height: 24px;
`;

const EngName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #a7a7a7;
  line-height: 21px;
`;

export default MedicalKorDepartureLocation;
